/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import withStyles from 'react-jss';
import styles from './styles';

const InputDataList = ({
	input, classes, image, label, value, placeholder, type, meta: { touched, error },
	data, disabled,
}) => {
	const InputTextClasses = [
		classes.root,
		classes.placeholder,
		classes.line,
	].join(' ');
	return (
		<div className={classes.inputDivStyle}>
			{image && <img alt="images" className={classes.inputImgStyles} src={image} />}
			<div className={classes.inputContainer}>
				<label className={[classes.label, classes.inputLabel, classes.inputLabelStyle].join(' ')}>
					{label}
				</label>
				<input
					disabled={disabled}
					value={value}
					className={InputTextClasses}
					placeholder={placeholder}
					type={type}
					list={label}
					{...input}
				/>
				<datalist id={label}>
					{data.map((item) => <option value={item.name} />)}
				</datalist>
				{touched && error && <span className={classes.errorInputStyle}>{error}</span>}
			</div>
		</div>
	);
};

export default withStyles(styles)(InputDataList);
